<template>
  <div>
    <IconButton
      hasNoBackground
      icon="file"
      iconPosition="left"
      :text="`Run ${report.name} Report`"
      type="informational"
      @click="generateReport"
    />

    <ModalConfirmation
      hasBlur
      :showModal="modalData.visible"
      :title="modalData.headerText"
    >
      <template v-slot:body>
        <ParagraphBody>
          {{ modalData.bodyText }}
          <Link
            :href="storedReportsRoute"
            text="Stored Reports Page"
          />.
        </ParagraphBody>
      </template>

      <template v-slot:footer>
        <ButtonGroup
          :isFullWidth="false"
        >
          <ButtonSecondary
            :hasOutline="false"
            :text="modalData.secondaryActionText"
            @click="modalData.handleSecondaryAction"
          />
          <Button
            :text="modalData.mainActionText"
            @click="modalData.handleMainAction"
          />
        </ButtonGroup>
      </template>
    </ModalConfirmation>
  </div>
</template>

<script>
import {
  Button,
  ButtonGroup,
  ButtonSecondary,
  IconButton,
  Link,
  ModalConfirmation,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';
import ReportMetadata from 'client/Reports/ReportMetadata';
import Util from 'client/util/Util';
import axios from 'axios';

export default {
  name: 'RunReportButton',

  components: {
    Button,
    ButtonGroup,
    ButtonSecondary,
    IconButton,
    Link,
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    reportType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      modalData: {
        bodyText: `Reports may take a few moments to complete. Once the requested report completes,
          it will be available for download (CSV/JSON) from the `,
        handleMainAction: () => { this.modalData.visible = false; },
        handleSecondaryAction: () => {
          this.modalData.visible = false;
          Util.redirect('/#/reports/downloads');
        },
        headerText: 'Report Processing',
        mainActionText: 'Ok',
        secondaryActionText: 'Go To Stored Reports',
        visible: false,
      },
      storedReportsRoute: '/#/reports/downloads',
      report: ReportMetadata[this.reportType],
    };
  },

  methods: {
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
    ]),

    confirmExport() {
      this.modalData.visible = true;
    },

    async generateReport() {
      try {
        await this.report.fetchReport({}, {});
      } catch (err) {
        if (axios.isCancel(err)) {
          this.triggerErrorNotification({
            message: 'Report export cancelled.',
          });
        } else {
          this.triggerErrorNotification({
            message: `Error generating report. ${err.response.data.message}.`,
          });
        }
      } finally {
        this.confirmExport();
      }
    },
  },
};
</script>
